module.exports = __webpack_public_path__ + "static/fun-time/games/page008_game1/audio//14_orange.mp3";